import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Grid, IconButton, Typography } from '@mui/material';
import { CalculationSettingsMultiStain, CalculationSettingsSingleStain, Study } from 'interfaces/study';
import { includes, map, split } from 'lodash';
import React from 'react';
import { useStainTypeIdToDisplayName } from 'utils/useStainTypeIdToDisplayName';
import { StainVector } from './StainVector';

export const DeconvolutionStainMapping: React.FC<{
  stainTypeId: string;
  updatedSettings: Study['settings'];
  setUpdatedSettings: React.Dispatch<React.SetStateAction<Study['settings']>>;
}> = ({ stainTypeId, updatedSettings, setUpdatedSettings }) => {
  const isMultiStain = includes(stainTypeId, '_');
  const updatedDeconvolutionSettings = updatedSettings.deconvolutionSettings?.calculationSettings;
  const { stainTypeIdToDisplayName } = useStainTypeIdToDisplayName();

  const onDeleteStain = () => {
    setUpdatedSettings((prevSettings) => {
      const updatedCalculationSettings = {
        ...prevSettings.deconvolutionSettings.calculationSettings,
      };
      delete updatedCalculationSettings[stainTypeId];
      return {
        ...prevSettings,
        deconvolutionSettings: {
          ...prevSettings.deconvolutionSettings,
          calculationSettings: updatedCalculationSettings,
        },
      };
    });
  };

  return (
    <Grid container direction="row" justifyContent="space-between" alignItems="center">
      {isMultiStain ? (
        <Grid item container xs={10} direction={'column'} alignItems={'center'}>
          <Grid item container xs={2} alignItems={'center'}>
            <Grid item xs={10}>
              <Typography variant="h4">{stainTypeIdToDisplayName(stainTypeId)}</Typography>
            </Grid>
            <Grid item xs={2}>
              <IconButton size="small" onClick={onDeleteStain}>
                <DeleteOutlineIcon />
              </IconButton>
            </Grid>
          </Grid>
          {map(split(stainTypeId, '_'), (stainId) => (
            <Grid item container xs={12} key={stainId} alignItems={'center'}>
              <Grid item xs={2}>
                <Typography variant="caption">{stainId}</Typography>
              </Grid>
              <StainVector
                stainVector={(updatedDeconvolutionSettings as CalculationSettingsMultiStain)?.[stainTypeId]?.[stainId]}
                setVector={(newVector: number[]) =>
                  setUpdatedSettings(
                    (prevSettings: Study['settings']) =>
                      ({
                        ...prevSettings,
                        deconvolutionSettings: {
                          ...prevSettings.deconvolutionSettings,
                          calculationSettings: {
                            ...prevSettings.deconvolutionSettings.calculationSettings,
                            [stainTypeId]: {
                              ...(
                                prevSettings.deconvolutionSettings.calculationSettings as CalculationSettingsMultiStain
                              )[stainTypeId],
                              [stainId]: newVector,
                            },
                          },
                        },
                      } as Study['settings'])
                  )
                }
              />
            </Grid>
          ))}
        </Grid>
      ) : (
        <Grid item container xs={10} alignItems={'center'}>
          <Grid item xs={2}>
            <Typography variant="h4">{stainTypeIdToDisplayName(stainTypeId)}</Typography>
          </Grid>
          <StainVector
            stainVector={(updatedDeconvolutionSettings as CalculationSettingsSingleStain)?.[stainTypeId]}
            setVector={(newVector: number[]) =>
              setUpdatedSettings(
                (prevSettings) =>
                  ({
                    ...prevSettings,
                    deconvolutionSettings: {
                      ...prevSettings.deconvolutionSettings,
                      calculationSettings: {
                        ...prevSettings.deconvolutionSettings.calculationSettings,
                        [stainTypeId]: newVector,
                      },
                    },
                  } as Study['settings'])
              )
            }
          />
          <Grid item xs={2}>
            <IconButton size="small" onClick={onDeleteStain}>
              <DeleteOutlineIcon />
            </IconButton>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};
